import { Dialog } from "primereact/dialog";
import { ICompletedTrainingsRating } from "./Table";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import { Column } from "primereact/column";
import { Fetch } from "../../../shared/Fetch";
import { RatingAnswers } from "./RatingAnswers";
import { ILogin } from "../../../models/Login";
import { Button } from "primereact/button";
import { ApproveRejectRating } from "./ApproveRejectRating";

interface IProps {
    singleData: ICompletedTrainingsRating,
    hideDialog: () => void,
    open: boolean,
    toast: any,
}

export interface ITrainingRatingDetails {
    rating_ID?: number,
    login_ID?: number,
    user_Name?: string,
    company_Name?: string,
    branchName?: string,
    rating?: number,
    added_On?: Date,
    approve_Status?: boolean,
    approved_By?: number,
    approved_On?: Date,
    comment?: string,
}

export const AllRating = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITrainingRatingDetails>, loading: boolean });
    const [openAnswerView, setOpenAnswerView] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingRatingDetails });
    const [openApprove, setOpenApprove] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingRatingDetails });
    const [openRejectionReason, setOpenRejectionReason] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ITrainingRatingDetails });
    const dt = useRef<any>(null);

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const onHide = () => {
        props.hideDialog();
    }
    const onHide2 = () => {
        setOpenRejectionReason({ open: false, singleData: {} });
    }
    const header = () => {
        return <p>Ratings</p>;
    }

    const add_Date = (rowData: ITrainingRatingDetails) => {
        let date;
        if (rowData.added_On) date = format(new Date(rowData.added_On), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("CarnivalTraining/getRatingDetails", "GET", null, `scheduleID=${props.singleData.schedule_ID}`, props.toast);
        if (response) {
            const data: ITrainingRatingDetails[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const ViewButtonForAns = (rowData: ITrainingRatingDetails) => {
        return <p className="cursor-pointer text-cyan-700 underline" onClick={() => setOpenAnswerView({ open: true, singleData: rowData })}>Answers</p>;
    }

    const ratingStars = (rowData: ITrainingRatingDetails) => {
        let stars: string[] = ["★", "★", "★", "★", "★"];
        return <p>{stars.map((el: string, index: number) => <span style={{ color: index <= ((rowData.rating || 0) - 1) ? "#FFD700" : "#ccc" }}>{el}</span>)}</p>
    }

    const action = (rowData: ITrainingRatingDetails) => {
        return (
            <div className="flex gap-3">
                {(rowData.approve_Status === null || (_roles.includes(1) || _roles.includes(26))) && <Button icon="pi pi-pencil" className="p-button-rounded p-button p-button-text mr-1" onClick={() => setOpenApprove({ open: true, singleData: rowData })} />}
            </div>
        );
    };

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '60vw' }} header="Ratings" modal className="p-fluid" onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                lazy dataKey="schedule_ID"
                emptyMessage="No Record found."
                value={tableData.tableData} loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="Trainee" />
                <Column field="company_Name" header="Company" />
                <Column field="branchName" header="Branch" />
                <Column field="rating" header="Rating" body={ratingStars} />
                <Column field="" header="Answers" body={ViewButtonForAns} />
                <Column field="added_On" header="Rated On" body={add_Date} />
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(11)) && <Column field="approve_Status" header="Approve Status" body={(rowData: ITrainingRatingDetails) => <p className={(rowData.approve_Status !== null && rowData.approve_Status === false) ? "cursor-pointer text-cyan-700 underline" : ""} onClick={() => {
                    if (rowData.comment !== null && rowData.approve_Status === false) setOpenRejectionReason({ open: true, singleData: rowData });
                }}>{rowData.approve_Status === true ? "Accepted" : (rowData.approve_Status === false ? `Rejected` : "")}</p>} />}
                {(_roles.includes(1) || _roles.includes(26) || _roles.includes(11)) && <Column header="Action" body={action} />}
            </DataTable>
            <RatingAnswers open={openAnswerView.open} singleData={openAnswerView.singleData} hideDialog={() => setOpenAnswerView({ open: false, singleData: {} })} toast={props.toast} />
            <ApproveRejectRating open={openApprove.open} singleData={openApprove.singleData} hideDialog={() => setOpenApprove({ open: false, singleData: {} })} reloadTable={() => loadTableData()} toast={props.toast} />
            <Dialog visible={openRejectionReason.open} style={{ width: '30vw' }} header="Rejection Reason" modal className="p-fluid" onHide={onHide2}>
                <p>{openRejectionReason.singleData?.comment}</p>
            </Dialog>
        </Dialog>
    );
}